import React, { memo } from 'react';
import { Badge, ListGroup } from '../../../ui-kit';
import SkillIconList from '../../../general/SkillIconList';
import UserContact from '../../../general/UserContact';
import AvailabilityCodeIcon from '../../../general/AvailabilityCodeIcon';

const TeamMember = memo(({ member, groupId }) => (
  <ListGroup.Item>
    <UserContact userId={member.user.id} groupAvailabilityContextId={groupId} displayFullName={false} />
    <AvailabilityCodeIcon code={member.availabilityCode} />
    <div className="float-right">
      {member.assignedFunctions.length > 0 && (
        <Badge className="me-2" style={{ verticalAlign: 'text-top', backgroundColor: 'var(--bs-info)' }}>
          <SkillIconList skills={member.assignedFunctions} />
        </Badge>
      )}
      <SkillIconList maxDisplay={5} skills={member.skills} showScheduleIconsOnly={true} />
    </div>
  </ListGroup.Item>
));

TeamMember.displayName = 'TeamMember';
export default TeamMember;
